import React from 'react';
import { companyInfo } from '../data/mock';

const Hero = () => {
  return (
    <section className="relative min-h-[100svh] sm:min-h-[85vh] bg-gradient-to-br from-[#0077B6] via-[#0088cc] to-[#b8dce8] overflow-hidden pt-24 sm:pt-32">
      {/* Background Decorative Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 right-[-100px] w-[300px] sm:w-[600px] h-[300px] sm:h-[600px] rounded-full bg-gradient-to-br from-[#b8dce8]/50 to-transparent" />
        <div className="absolute bottom-[-100px] sm:bottom-[-200px] right-[50px] sm:right-[100px] w-[250px] sm:w-[500px] h-[250px] sm:h-[500px] rounded-full bg-[#0a2342]/80" />
        <div className="absolute bottom-[-75px] sm:bottom-[-150px] right-[75px] sm:right-[150px] w-[200px] sm:w-[400px] h-[200px] sm:h-[400px] rounded-full bg-gradient-to-t from-[#0077B6] to-[#0a2342] opacity-90" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 py-8 sm:py-16">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          {/* Left Content */}
          <div className="text-white text-center lg:text-left">
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6">
              Enterprise IT<br className="hidden sm:block" />
              <span className="sm:hidden"> </span>Solutions &<br className="hidden sm:block" />
              <span className="sm:hidden"> </span>Cybersecurity
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/90 mb-6 sm:mb-8 max-w-xl mx-auto lg:mx-0">
              {companyInfo.description}
            </p>
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4 justify-center lg:justify-start">
              <a
                href="#contact"
                className="px-6 sm:px-8 py-3 sm:py-3.5 bg-white text-[#0a2342] font-semibold rounded-full hover:bg-gray-100 transition-colors shadow-lg text-center"
              >
                Schedule Consultation
              </a>
              <a
                href="#services"
                className="px-6 sm:px-8 py-3 sm:py-3.5 border-2 border-white text-white font-semibold rounded-full hover:bg-white/10 transition-colors text-center"
              >
                Explore Solutions
              </a>
            </div>
          </div>

          {/* Right Graphic - Abstract 3D Sphere */}
          <div className="hidden lg:flex justify-center items-center" aria-hidden="true">
            <div className="relative">
              {/* Outer ring */}
              <div className="absolute inset-0 w-[400px] h-[400px] rounded-full border-[15px] border-[#b8dce8]/30 transform rotate-12" />
              {/* Main sphere */}
              <div className="w-[350px] h-[350px] rounded-full bg-gradient-to-br from-[#0a2342] via-[#0a2342] to-[#1a3a5c] shadow-2xl flex items-center justify-center">
                <div className="w-[300px] h-[300px] rounded-full bg-gradient-to-tl from-[#0077B6]/20 to-transparent" />
              </div>
              {/* Accent ring */}
              <div className="absolute -bottom-8 -left-8 w-[150px] h-[150px] rounded-full border-[10px] border-[#0077B6]/40" />
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" className="w-full h-[60px] sm:h-auto">
          <path d="M0 120L1440 120L1440 60C1440 60 1320 0 1080 0C840 0 720 60 480 60C240 60 120 30 0 60L0 120Z" fill="#0a2342" />
        </svg>
      </div>
    </section>
  );
};

export default Hero;
